<template>
  <van-dialog
    theme="round-button"
    class="custom-dialog"
    v-model="show"
    :show-cancel-button="!canClose"
    :show-confirm-button="canClose"
    :cancel-button-text="confirmButtonText"
    :confirm-button-text="confirmButtonText"
    title="提示"
    :before-close="beforeClose"
    @confirm="confirm"
  >
    <div class="dialog-content">
      <span class="color-red">严禁推销或更换电瓶，一经发现处以高额罚款</span>
    </div>
  </van-dialog>
</template>

<script>
const initData = () => {
  return {
    confirmCallback: null
  };
};
export default {
  name: 'TipsDelayDialog',
  data() {
    return {
      data: initData(),
      show: false,
      timer: null,
      counter: 3,
      confirmButtonText: '知道了（3）',
      canClose: false // 3s后可关闭
    };
  },
  destroyed() {
    this.clearTimer();
  },
  methods: {
    open(data) {
      data && (this.data = { ...this.data, ...data });
      this.show = true;
      this.initTimer();
    },
    close() {
      this.show = false;
    },
    beforeClose(action, done) {
      console.log(action, done);
      if (action === 'cancel') {
        done(false);
      }
    },
    confirm() {
      this.close();
      this.data.confirmCallback && this.data.confirmCallback.apply(this);
    },
    dealButtonText() {
      console.log('dealButtonText', this.confirmButtonText, this.counter);
      if (this.counter > 0) {
        this.confirmButtonText = `知道了（${this.counter}）`;
        this.counter--;
        this.canClose = false;
      } else {
        this.confirmButtonText = `知道了`;
        this.canClose = true;
        this.clearTimer();
      }
      console.log('dealButtonText2', this.confirmButtonText, this.counter);
    },
    initTimer() {
      if (this.timer) {
        return;
      }
      this.dealButtonText();
      this.timer = setInterval(this.dealButtonText, 1000);
    },
    clearTimer() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.color-red {
  color: #ee0a24;
}
.custom-dialog{
  &.van-dialog ::v-deep {
    .van-dialog__header{
      padding: 14px 0;

      text-align: center;

      color: #383838;
      border-radius: 8px 8px 0px 0px;
      background: #FFFFFF;
      box-shadow: inset 0px -1px 0px 0px rgba(230,230,230,1);

      font-family: PingFangSC-Regular;
      font-size: 16px;
      font-weight: 400;
    }
    .van-dialog__content{
      .dialog-content{
        padding: 24px 16px;

        text-align: center;
        letter-spacing: -0.41px;

        color: #646464;

        font-family: PingFangSC-Regular;
        font-size: 16px;
        font-weight: 400;
        line-height: 22px;

        .color-orange{
          color: #FF8A59;
        }
      }
    }
    .van-dialog__footer {
      padding: 0 16px 24px;
      .van-button {
        height: 40px;

        text-align: center;
        letter-spacing: -0.41px;

        & + .van-button {
          margin-left: 17px;
        }
        &.van-dialog__cancel {
          color: #646464;
          border-radius: 8px;
          background: #EDF2F7;

          font-family: PingFangSC-Regular;
          font-size: 16px;
          font-weight: 400;
        }
        &.van-dialog__confirm {
          color: #ffffff;
          border-radius: 8px;

          font-family: PingFangSC-Regular;
          font-size: 16px;
          font-weight: 400;
        }
      }
    }
  }
}
</style>
